(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-owned-videos"]) return;
  try {
    

(function($){

	$(document).ready(function() {
		
		$('.brand-video-slider').slick({
			slidesToShow: 2,
  			slidesToScroll: 1,
			infinite: true,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
		});

		$('.brand-video-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          $('video').trigger('pause');
        });

		
		if (window.matchMedia("(max-width: 767px)").matches) {
		
            $('.brand-video-slider').slick('unslick');  

        }
		
		
		//video play
		/*$('.brand-video-area button').click(function(){

			//$(this).siblings('video').attr('controls',true);
			//$(this).siblings('video').get(0).play();
			
			//$(this).remove();

        });*/



		$("a[href='#topProducts']").on('click', function(event) {

          if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            
            $('html, body').animate({
              scrollTop: ($(hash).offset().top - 152)
            }, 800, function(){
              
            });
          }

        });


	});

		
	
    
    


})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){

	jQuery('.tabs-links ul li a').click(function(){

	    var targetTab = jQuery(this).data('class');

    	jQuery('.all').hide();

    	jQuery('.'+targetTab).show();


    });

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function($){
  $(function(){

    $('.top-scroll a')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });
  
  });

  $(window).scroll(function(){
    if($(document).scrollTop() > 200) {
      $('.top-scroll').fadeIn('300');
    } else {
      $('.top-scroll').fadeOut('300');
    }
  });
	
	$(window).scroll(function() { 
		var height = $(document).scrollTop();  
		if(height  > 40) {
            $(".menu-header").css('position', 'fixed');
            $(".menu-header").css('top', '100px');

            $(".middle-header").css('position' , 'fixed');

		} else{
			$(".menu-header").css('position','static');
			$(".middle-header").css('position','static');
		}
	});
	if($(window).width() < 768) {
		$(window).scroll(function() {    
			var height = $(document).scrollTop();  
			if(height  > 40) {
				$(".middle-header").css("position", "fixed");
				
			} else{
				$(".middle-header").css('position','static');
			}
		});
	}
	$('.addtocartbtn').on('click',function(){
		
		
		var pid = $(this).attr('id');
		
			$('.viewcart'+pid).css('display','block');
		
		
	})
	
	 $('body').on('click',function(){
	 
		$('.news-letter-popup').css('display','none');
	 })


})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hairapp"]) return;
  try {
    
						$ = jQuery;
      
							  $(document).ready(function(){
							  
								$('a[data-toggle="tab"]').click(function(){
							  
								var targetTab = $(this).attr('href');
							  
								$('.hair-quiz-tabs .tab-pane').removeClass('active');
									
								  $(targetTab).addClass('active');
							  
								});
							  
							  });
						
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function($){
    $(function(){  //document.ready

     $('#toggle').click(function(){
       $('.mobile-menu-area').slideDown(200);
     });
     
     $('#closeBtn').click(function(){
       $('.mobile-menu-area').slideUp(200);
     });

     $('.mobile-nav--button').click(function(){
       $(this).siblings('ul').stop().slideToggle();
     });

     $('.menu-tab-link ul li a').click(function(e){
          e.preventDefault();
          $('.menu-tab-link ul li').removeClass('active');
          $(this).parent('li').addClass('active');

          var target = $(this).attr('href');
          $('.menu-tab').removeClass('active');
          $(target).addClass('active');
      });

      $('.mega-parent a').click(function(e){
          e.preventDefault();
          $('.menu-menu-tabs').fadeToggle(300);
      });

      $('#closeModel').click(function(){
          $('.news-letter-popup').fadeOut(300);
      });

    });

    $(window).on('load', function(){
      if(localStorage.getItem('popState') != 'shown'){
        $(".news-letter-popup").delay(5000).fadeIn();
        localStorage.setItem('popState','shown')
      }
    });

})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  (function($){
    $(document).ready(function() {
       	$('.pro-slider').slick({
          	dots:false,
			slidesToShow: 3,
  			slidesToScroll: 1,
  			focusOnSelect: true,
			asNavFor: '.product-photo-container',
			vertical: true,
			verticalSwiping: true
        });


		$('.product-photo-container').slick({
			dots:false,
			asNavFor: '.pro-slider'
		})


        $('.tab-link').click(function(e){
          e.preventDefault();
          var targetItem = $(this).attr('href');
          $('.pro-tabs').removeClass('active');
          $(targetItem).addClass('active');
          $('.tab-link').parent('li').removeClass('active');
          $(this).parent('li').addClass('active');
        });

       
      function button() {
        if($('.single-product-page .wishlist-btn').hasClass('is-active')){
            $('.single-product-page .wishlist-btn').html('Remove to Wishlist');
            $('.single-product-page .wishlist-btn').after('<a href="https://waklee.myshopify.com/pages/wishlist" class="wishtlist-page">View Wishlist</a>');
          } else {
              $('.single-product-page .wishlist-btn').html('Add to Wishlist');
              $('.single-product-page .wishtlist-page').remove();
        }
        
      }

      button();

      $('.single-product-page .wishlist-btn').click(function(){

        if($(this).hasClass('is-active')){
            $(this).html('Remove to Wishlist');
            $(this).after('<a href="/pages/wishlist" class="wishtlist-page">View Wishlist</a>');
        } else {
            $(this).html('Add to Wishlist');
            $('.wishtlist-page').remove();
        }

      });



	$('.review-video video').on('click', function(){

    var targetV = $(this).attr('id');

    document.getElementById(targetV).play();

    $(this).attr('controls', 'controls')


    });



    });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function($){
    $(document).ready(function() {
        $('.testimonial-slider').flexslider({
        animation: "slide",
        animationLoop: false, 
        minItems: 1,
        maxItems: 1
        });
    });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-black-owned-product"]) return;
  try {
    

(function($){

	$(document).ready(function() {

		$('.black-products').slick({
			infinite: true,
  			slidesToShow: 3,
  			slidesToScroll: 1,
			responsive: [
                {
                  breakpoint: 1026,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                    
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
                
              ]
		});

	 	

	});

})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-black-owned-productn-new"]) return;
  try {
    

(function($){

	$(document).ready(function() {

		$('.black-products').slick({
			infinite: true,
  			slidesToShow: 3,
  			slidesToScroll: 1,
			responsive: [
                {
                  breakpoint: 1026,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                    
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
                
              ]
		});

	 	

	});

})(jQuery);


  } catch(e) { console.error(e); }
})();
})();
